import styled from "styled-components";
import NavBar from "../Componentes/NavBar"
import TabelaItens from "../Modulos/Checklist/Itens/TabelaItens";

const Corpo = styled.div`
    width: 100%;
    height: calc( 100% - 70px );
    background-color: #242D34;
    display: flex;
    flex-direction: column;
    padding: 5px;
    box-sizing: border-box;
`

const ChecklistItens = () => {
    return(
        <>
            <NavBar title="CHECKLIST ITENS" prevDest="modulo/ssma/check-list" />
            <Corpo>
                <TabelaItens />
            </Corpo>
        </>
    )
}

export default ChecklistItens;